<template>
  <div class="row child-component">
    <div
      class="col-lg-7 col-md-8 col-sm-8 col-xs-6 mx-auto">
      <!-- <div class="d-block row col-lg-8 offset-lg-2">
            <OmniSelect :showSearch="false" :showSelectAll="false" selectAllText="All" unSelectAllText="None" multiple="true" v-model="MediaVendor.MediaTypeCategory" :options="MediaTypeCategory" name="Media Category" placeholder="Select Media Category" />
        </div> -->
      <div class="d-block row col-lg-8 mx-auto">
        <b-form-group label="Is this for a Special Pay Rep?">
          <b-form-radio-group
            id="media-rep"
            v-model="MediaVendor.IsMediaRepRequest"
            name="media-rep"
          >
            <b-form-radio value="true">Yes</b-form-radio>
            <b-form-radio value="false">No</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
      <div class="d-block row col-lg-8 mx-auto" v-if="this.MediaVendor.IsMediaRepRequest">
        <b-form-group>
          <slot name="label">
            <span name="vendor-digital-media">Is this a request for digital media (Prisma/Print Toolkit)?</span>
            <custom-tooltip
              :content="
                'Digital media type Search, Interactive, Social, Video, Bundled, Unbundled, Digital Audio will be added to list if yes'
              "
            ></custom-tooltip>
          </slot>
          <b-form-radio-group
            v-model="MediaVendor.IsDigitalMedia"
            id="digital-media"
            name="digital-media"
          >
            <b-form-radio value="true">Yes</b-form-radio>
            <b-form-radio value="false">No</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
      <div
        class="d-block row col-lg-8 mx-auto px-1"
        v-if="MediaVendor.IsDigitalMedia == 'true' || MediaVendor.IsDigitalMedia == true"
      >
        <div class="mx-2" style="margin-top:35px">
          <OmniSelect
            v-model="MediaVendor.DigitalMediaType"
            :options="MediaVendor.MediaTypesWithDigital"
            name="Digital Media Type"
            placeholder="Select Media Type"
          />
        </div>
      </div>
      <div class="d-block row col-lg-8 mx-auto media-type-container" style="margin-top:35px" v-if="IsMediaTypeRequired
      && MediaVendor.IsDigitalMedia">
        <div class="d-flex justify-content-between">
          <label class="w-75">Is this vendor needed for an additional media? Select any other media type if required</label>
          <span
            :class="MediaVendor.MediaType ? 'btn-clear d-flex align-items-center justify-content-center font-weight-bold px-2' : 'd-none'"
            @click="clearMediaSelection"
            >Clear Media Type</span
          >
        </div>
        <OmniSelect
          v-model="MediaVendor.MediaType"
          :options="MediaTypesWithoutDigital"
          placeholder="Select Media Type"
        />
      </div>
      <div
        class="d-block row col-lg-8 mx-auto my-3"
        v-if="(MediaVendor.IsMediaRepRequest === false || MediaVendor.IsMediaRepRequest === 'false') && (MediaVendor.MediaType === 'TV' || MediaVendor.MediaType === 'Radio')">
        <b-form-input
          @blur="SetDirty('CallLetters')"
          @focus="ResetDirty('CallLetters')"
          autocomplete="off"
          id="CallLetters"
          class="omniipclass"
          v-model="MediaVendor.CallLetters"
          placeholder="Enter Call Letters"
        ></b-form-input>
        <b-form-input
          @blur="SetDirty('MarketNumbers')"
          @focus="ResetDirty('MarketNumbers')"
          autocomplete="off"
          id="MarketNumbers"
          class="omniipclass mt-3"
          v-model="MediaVendor.MarketNumbers"
          placeholder="Enter Market Numbers"
        ></b-form-input>
        <div
          class="error-message-format"
          v-if="
            $v.MediaVendor.MarketNumbers.$dirty &&
              !$v.MediaVendor.MarketNumbers.required
          "
        >
          Required field
        </div>

        <b-form-input
          @blur="SetDirty('MarketName')"
          @focus="ResetDirty('markMarketNameetName')"
          autocomplete="off"
          id="MarketName"
          class="omniipclass mt-3"
          v-model="MediaVendor.MarketName"
          placeholder="Enter Market Name"
        ></b-form-input>
        <div
          class="error-message-format"
          v-if="
            $v.MediaVendor.MarketName.$dirty &&
              !$v.MediaVendor.MarketName.required
          "
        >
          Required field
        </div>
      </div>
      <div class="d-block row col-lg-8 mx-auto" v-if="MediaRepRequest && this.MediaVendor.IsDigitalMedia">
        <label>Please attach an invoice copy</label>
        <vue-dropzone v-on:vdropzone-mounted="mountedmyVueDropzone"
          :duplicateCheck="true"
          ref="myVueDropzone"
          id="dropzone"
          :useCustomSlot="true"
          class="customdropzone"
          :include-styling="false"
          :options="dropzoneOptions"
          v-on:vdropzone-file-added="UploadedToDropzone"
          v-on:vdropzone-removed-file="RemovedFromDropzone"
        >
          <div class="dropzone-custom-content">
            <p class="Drag-and-drop-file-h">
              <b-img
                :src="closeFilterIcon"
                style="margin-top: -7px !important; font-family: 'Open Sans'"
              />
              Drag and drop file here or
              <span class="draganddropspan"> browse </span>
            </p>
          </div>
        </vue-dropzone>
        <div class="note-section mt-2">
          <p>Acceptable file types: {{ AllowedFileUploadTypes }}.</p>
        </div>
      </div>
      <!-- <div class="d-block row col-lg-8 offset-lg-2">
            <OmniCustomSelect  :groupSelect="true" :showSearch="false" :showSelectAll="false" selectAllText="All" unSelectAllText="None" multiple="true" v-model="MediaVendor.MediaTypes" :options="MediaTypes" name="Media Types" placeholder="Select Media Types" />
        </div> -->
      <p>
    </p>
    </div>
    <div
      class="form-group pt-60 text-right  footer-buttons"
      style="padding-right:96px !important;"
    >
      <button class="btn btn-link text-uppercase" @click="Cancel()">
        CANCEL
      </button>
      <button v-if="IsDraftVisible" class="text-uppercase btn btn-secondary btn-primary" @click="SaveAsDraft()">
          SAVE FOR LATER
      </button>
      <button class="text-uppercase btn custom-button btn-primary" @click="Previous()">
          BACK
      </button>
      <button
        class="text-uppercase btn custom-button btn-primary"
        @click="Next()"
        :disabled="this.$v.$invalid"
      >
        NEXT
      </button>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapGetters } from "vuex";
import store from "@/store";
import * as AllowedFileUploadExtensions from "../../../utilities/AllowedFileUploadExtensions";
import { required, minLength, requiredIf } from "vuelidate/lib/validators";
import mediaVendorSaveAsDraft from '../../../mixins/mediaVendorSaveAsDraft';
import {
  NETWithoutDigital,
  NETDigital,
  SPOTWithoutDigital,
  SPOTDigital,
  PRINTWithoutDigital,
  PRINTDigital
} from "../../../utilities/MediaList";

// import OmniCustomSelect from "../../Common/OmniCustomSelect";
export default {
  mixins: [mediaVendorSaveAsDraft],
  components: {
    vueDropzone: vue2Dropzone,
    // OmniCustomSelect
  },
  props: {
    id: {
      type: Number,
      required: false,
    },
    isDraft: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      DigitalMediaNet: [],
      DigitalMediaSpot: [],
      DigitalMediaPrint: [],
      newFile: [],
      FilesUploaded: false,
      // MediaTypes:[],
      NetMediaOptions: [
        {
          label: "Cable FEP Streaming",
          value: "Cable FEP Streaming",
        },
        {
          label: "Cable VOD",
          value: "Cable VOD",
        },
        {
          label: "Network Streaming",
          value: "Network Streaming",
        },
      ],
      // MediaVendor: {
      //     IsMediaRepRequest: null,
      //     MediaTypes: [],
      //     IsDigitalMedia:null

      // },
      AllowedFileUploadTypes: AllowedFileUploadExtensions.FileUploadExtensions.join(", "),
      dropzoneOptions: {
        paramName: "file",
        //params: {'param_1':'xyz','para_2': localid },
        previewTemplate: this.template(),
        url: `${process.env.VUE_APP_API_ROOT}api/v1/mdm/Upload`,
        uploadMultiple: true,
        maxFiles: 5,
        minFiles: 1,
        maxFilesize: 10,
        addRemoveLinks: false,
        parallelUploads: 5,
        createImageThumbnails: false,
        autoProcessQueue: true,
        init: function() {
          this.on("addedfile", function(file) {
            if (this.files.length > 5) {
              this.removeFile(file);
              window.alert("Maximum File Upload limit is 5!");
            }
          });

          this.on("removedfile", function() {});
        },
        accept: function(file, done) {
          let fileExtension = file.name.split('.').pop().toLowerCase();
            if (!AllowedFileUploadExtensions.FileUploadExtensions.includes(fileExtension)) {
              store.dispatch(
                  "progress/setErrorMessage",
                  `Unsupported file type. Please upload a valid file type.`
              );
              this.removeFile(file);
            } else {
              done();
            }
          },
        },
        uploadedFiles:[] ,
        apiFiles:[] ,
    };
  },
  validations: {
    MediaVendor: {
      IsDigitalMedia: {
        required: requiredIf(function() {
          return this.MediaVendor.IsMediaRepRequest;
        }),
      },
      MarketName: {
        required: requiredIf(function(model) {
            return (model.IsMediaRepRequest === false || model.IsMediaRepRequest === 'false') && this.subMediaData ;
        }),
      },
      MarketNumbers: {
        required: requiredIf(function(model) {
          return (model.IsMediaRepRequest === false || model.IsMediaRepRequest === 'false') && this.subMediaData ;
        }),
      },
      IsMediaRepRequest: {
        required: required,
      },
      DigitalMediaType:{
        required: requiredIf(function() {
          return this.MediaVendor.IsDigitalMedia == true || this.MediaVendor.IsDigitalMedia == 'true';
        }),
      },
      MediaType:{
        required: requiredIf(function() {
          return this.IsMediaTypeRequired &&
          (this.MediaVendor.IsDigitalMedia==false || this.MediaVendor.IsDigitalMedia=='false');
        }),
      },
      VendorInvoiceCopyFiles: {
        minLength: minLength(1),
        required: requiredIf(function() {
          return (this.MediaVendor.IsMediaRepRequest == true || this.MediaVendor.IsMediaRepRequest == 'true') && this.MediaVendor.IsDigitalMedia;
        }),
      },
    },
  },
  activated() {
    this.$parent.$emit("stepInitiated", this.$route.meta.tabIndex);
  },
  async mounted() {
     await this.GetAllMediaTypes();
    },
  computed: {
    IsMediaTypeRequired() {
      return !((this.MediaVendor.IsMediaRepRequest == 'true' || this.MediaVendor.IsMediaRepRequest == true)
      && (this.MediaVendor.IsDigitalMedia == 'true' || this.MediaVendor.IsDigitalMedia == true))
    },
    subMediaData() {
      return (
        this.MediaVendor.MediaType === "TV" ||
        this.MediaVendor.MediaType === "Radio"
      );
    },
    IsEdit() {
      return this.id && !isNaN(this.id) && parseInt(this.id) > 0 ? true : false;
    },
    ...mapGetters("mediavendor", {
      MediaVendor: "MediaVendor",
    }),
    MediaTypeCategory() {
      return [
        {
          label: "Normal",
          value: "1",
        },
        {
          label: "Digital",
          value: "2",
        },
      ];
    },
    MediaTypes() {
      let list = [];
      list.push({
        label: "Net",
        value: NETDigital,
      });
      list.push({
        label: "Spot",
        value: SPOTDigital,
      });
      list.push({
        label: "Print",
        value: PRINTDigital,
      });
      return list;
    },
    MediaTypesWithoutDigital() {
      let list = [];
      list.push({
        label: "Net",
        value: NETWithoutDigital,
      });
      list.push({
        label: "Spot",
        value: SPOTWithoutDigital,
      });
      list.push({
        label: "Print",
        value: PRINTWithoutDigital,
      });
      return list;
    },
    MediaRepRequest() {
      if(this.MediaVendor.IsMediaRepRequest == true || this.MediaVendor.IsMediaRepRequest == "true") {
        return true;
      }  if (this.MediaVendor.IsMediaRepRequest == false || this.MediaVendor.IsMediaRepRequest == "false"){
        return false;
      } else {
        return null;
      }
    },
    IsDraftVisible() {
      return this.id == null || this.id == 0 || this.isDraft == true;
    },
  },
  methods: {
      mountedmyVueDropzone() {
          if ((this.MediaVendor.ID > 0 && this.FilesUploaded == false) || this.isDraft === true) {
              this.ManuallyUploadFiles(this.MediaVendor.VendorInvoiceCopyFiles);
              this.$set(this.MediaVendor, "VendorInvoiceCopyFiles", this.GetFilesObject());
          }
      },
    SetDirty(property) {
      this.$v.MediaVendor[property].$touch();
    },
    ResetDirty(property) {
      this.$v.MediaVendor[property].$reset();
    },
    clearMediaSelection() {
      this.MediaVendor.MediaType = "";
      this.MediaVendor.CallLetters = "";
      this.MediaVendor.MarketNumbers = "";
      this.MediaVendor.MarketName = "";
    },
    RenderUploadedFiles(files) {
            if (this.$refs.myVueDropzone != null) {
                if (files != null && files.length > 0 && this.FilesUploaded == false) {
                    files.forEach((fileUploaded) => {
                        let file = {
                            size: fileUploaded.Length,
                            name: fileUploaded.Name,
                            type: fileUploaded.Extension,
                        };
                        var url = fileUploaded.FullName;
                        this.$refs.myVueDropzone.manuallyAddFile(file, url);
                    });
                }
                this.FilesUploaded = true;
            }
    },
    // SetErrorMessage(message, ex) {
    //     this.$store.dispatch(
    //         "progress/setErrorMessage",
    //         `${message}. The error is ${ex}`
    //     );
    // },
    // mountedmyVueDropzone() {
    //     if (this.MediaVendor.ID > 0 && this.FilesUploaded == false) {
    //         this.ManuallyUploadFiles(this.MediaVendor.VendorInvoiceCopyFiles);
    //     }
    // },
    ManuallyUploadFiles(files) {
      if (this.$refs.myVueDropzone != null) {
        if (files != null && files.length > 0 && this.FilesUploaded == false) {
          files.forEach((fileUploaded) => {
            let file = {
              size: fileUploaded.Length,
              name: fileUploaded.Name,
              type: fileUploaded.Extension,
            };
            var url = fileUploaded.FullName;
            this.$refs.myVueDropzone.manuallyAddFile(file, url);
          });
        }
        this.FilesUploaded = true;
      }
    },
    UploadedToDropzone() {
      this.$set(
        this.MediaVendor,
        "VendorInvoiceCopyFiles",
        this.GetFilesObject()
      );
    },
    RemovedFromDropzone() {
      this.$set(
        this.MediaVendor,
        "VendorInvoiceCopyFiles",
        this.GetFilesObject()
      );
    },
        GetFilesObject() {
            let files = [];
            const dropzone = this.$refs.myVueDropzone;
            dropzone.processQueue();
            if (this.$refs.myVueDropzone.dropzone.files && this.$refs.myVueDropzone.dropzone.files.length > 0) {
                let filesExists = this.$refs.myVueDropzone.dropzone.files;
                for (let i = 0; i < filesExists.length; i++) {
                    files.push({
                        name: filesExists[i].name,
                        file: filesExists[i]
                    });
                }
                return files;
            } else {
                return files;
            }
        },
        fileUploaded(file) {
          this.uploadedFiles.push(file)
        },
    template: function() {
      return `<div class="dz-preview dz-file-preview" style='background-color:#ffffff !important;display:flex;'>

                <div class="dz-details" style='margin-right:79px !important;'>
                    <div class="dz-size" style="display:none;" ><span data-dz-size></span></div>
                    <div class="FileforNewClientxls-Copy" style="margin-left:20px;width:280px;cursor:default !important;" ><span style='word-break:break-all !important;font-size:14px !important;font-weight:400;font-stretch:normal;font-style: normal;line-height: 0.71;color: #00a1d2 !important; font-family:"Open Sans" !important;' data-dz-name></span></div>
                </div>
                <a>
                 <img data-dz-remove=""  style='' src='/icons/fileremove.svg'  @click="DeleteServerFile()" ></img>
                </a>
            </div>`;
    },
    Next() {
        this.$parent.$emit("stepChanged", this.$route.meta.tabIndex);
        if (this.id) {
            this.$router.push({
                name: "Media Vendor External Attachment",
                params: {
                    id: this.id,
                    isDraft: this.isDraft
                }
            });
        } else {
            this.$router.push({
                name: "Media Vendor External Attachment"
            });
        }
    },
    Previous() {
        if (this.id) {
            this.$router.push({
                name: "Media Vendor Employee Info",
                params: {
                    id: this.id,
                    isDraft: this.isDraft
                }
            });
        } else {
            this.$router.push({
                name: "Media Vendor Employee Info"
            });
        }
    },
    Cancel() {
      this.$router.push("/VendorRequests");
    },
  },
  watch: {
    "MediaVendor.IsMediaRepRequest": function(val,newVal) {
      if ((val == "true" || val == true) && newVal != null) {
        this.MediaVendor.IsDigitalMedia = null;
      }
      if (val && newVal != null) {
        this.MediaVendor.MediaType = "";
      }
    },
    "MediaVendor.IsDigitalMedia": function(val) {
      if (this.MediaVendor.IsMediaRepRequest == 'true' || this.MediaVendor.IsMediaRepRequest == true){
        if(val == "true" || val == true) {
          this.MediaVendor.MediaType = "";
        }
      }
      if (val === false || val === "false" || val == null) {
        this.MediaVendor.DigitalMediaType = [];
      }
    },
    "MediaVendor.MediaType": function(val) {
      PRINTWithoutDigital.find(el => {
        if(el.MediaType == val) {
          this.MediaVendor.PrintValueSelected = el.MediaType;
        }
      });
      if (val) {
        this.MediaVendor.CallLetters = "";
        this.MediaVendor.MarketNumbers = "";
        this.MediaVendor.MarketName = "";
      }
    },
  },
};
</script>

<style>
.media-type-container label {
  line-height: normal;
}
.media-type-container .floating-label-input {
    margin-top: 0px !important;
}
/*file upload starts*/
.btn-clear {
  font-size: 11px !important;
  color: #018db8;
  background: transparent;
  border: 1px solid #018db8;
  border-radius: 30px;
  height: 25px;
  cursor: pointer;
  min-width: 120px;
}

.customdropzone {
  width: 411px !important;
  height: auto !important;
  border-radius: 8px !important;
  border: dashed 2px #e9eef0 !important;
  background-color: #ffffff !important;
  cursor: pointer !important;
}

.Drag-and-drop-file-h {
  /* margin-left: 97px !important; */
  margin-top: 14px !important;
  width: 237px !important;
  height: 10px !important;
  font-family: "Open Sans" !important;
  font-size: 14px !important;
  font-weight: normal !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: 0.71 !important;
  letter-spacing: normal !important;
  color: #a2a9ad !important;
}

.draganddropspan {
  color: #00a1d2;
}

section#digital-media-options > ul > li > ul > li {
  pointer-events: none !important;
}

section#digital-media-options > ul > li > ul > li > div {
  opacity: 0.5 !important;
  /* Fade effect */
  cursor: not-allowed;
  /* Cursor change to disabled state*/
}

fieldset.form-group > div.first-child {
  color: rgb(77, 81, 97) !important;
  font-size: 11px !important;
  text-transform: uppercase !important;
}

/*file upload ends*/
</style>
